import './App.css';
import Homepage from '../Homepage/Homepage';

function App() {
  return (
    <div className="App">
      <Homepage/>
    </div>
  );
}

export default App;
